import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import { Button, PageHeader, Skeleton, Result } from 'antd';
import { AppConfig } from '@utils/config';
import history from '@utils/history';
import API from '@utils/api';

import UsersActions, { UsersSelectors } from '@redux/UsersRedux';
import { AppSelectors } from '@redux/AppRedux';

import BasicUserInfo from './BasicUserInfo';
import HouseKeeperInfo from './HouseKeeperInfo';
import EditUser from '../EditUser';
import { Switch, Route } from 'react-router-dom';

const RoleInfo = ({ role, userId, data }) => {
  if (role === 'house_keeper') {
    return <HouseKeeperInfo userId={userId} data={data} />;
  }
};

function ViewUserPage(props) {
  const {
    loadig,
    userData,
    regions,
    loadUser,
    resetUser,
    match: { params, url }
  } = props;

  const { id: userId } = params || {};

  useEffect(() => {
    loadUser(userId);

    return () => {
      resetUser();
    };
  }, [userId]);

  const render404 = () => {
    return (
      <div className="users main-page">
        <PageHeader
          title="User"
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="Users main-content">
          <Result
            status="403"
            title="403"
            subTitle="Sorry, you are not authorized to access this page."
          />
        </div>
      </div>
    );
  };

  const handleLoginAsPM = async () => {
    const { userID } = userData;
    const { result } = await API.getImpersonate(userID);
    const { authToken, refreshToken } = result;
    Cookies.set('authToken', authToken, { domain: AppConfig.DOMAIN });
    Cookies.set('refreshToken', refreshToken, { domain: AppConfig.DOMAIN });

    const win = window.open(AppConfig.WEB_APP_URL, '_blank');
    win.focus();
  };

  if (loadig) {
    return (
      <div className="users main-page">
        <PageHeader
          style={{
            border: '1px solid rgb(235, 237, 240)'
          }}
          onBack={() => history.goBack()}
        />

        <div className="coupon main-content">
          <Skeleton />
        </div>
      </div>
    );
  }

  const { userID: loadedId, firstName, lastName, role, roleInfo } =
    userData || {};
  if (!loadedId) {
    return render404();
  }
  const title = `${firstName} ${lastName}`;

  return (
    <div className="users main-page">
      <PageHeader
        title={title}
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
        subTitle={
          <Button
            key="1"
            type="primary"
            onClick={() => history.push(`${url}/edit`)}
          >
            Edit
          </Button>
        }
      >
        {role === 'property_manager' && (
          <div
            className="content"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center'
            }}
          >
            <div
              style={{
                width: '80%'
              }}
            ></div>
            <div className="extra">
              <Button
                type="primary"
                onClick={() => {
                  handleLoginAsPM();
                }}
              >
                Login as PM
              </Button>
            </div>
          </div>
        )}
      </PageHeader>
      <div className="main-content">
        <BasicUserInfo key={userId} data={userData} regions={regions} />
        {roleInfo && <RoleInfo role={role} userId={userId} data={roleInfo} />}
      </div>
    </div>
  );
}

ViewUserPage.propTypes = {
  match: PropTypes.object,
  loadUser: PropTypes.func,
  resetUser: PropTypes.func,
  loadig: PropTypes.bool,
  userData: PropTypes.object,
  regions: PropTypes.array
};

const mapDispatchToProps = dispatch => ({
  loadUser: userId => {
    dispatch(UsersActions.loadUserRequest(userId));
  },
  resetUser: () => {
    dispatch(UsersActions.setUserData(null));
  }
});

const mapStateToProps = state => ({
  loadig: UsersSelectors.selectLoading(state),
  userData: UsersSelectors.selectUserData(state),
  regions: AppSelectors.selectRegions(state)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewUserPage);
